import { post } from '@/api/request';

export const loadMenu = async () => {
  let list = [];
  list = await getMenuData();
  return list;
};

//接口查询菜单信息
async function getMenuData() {
  const systemtype = localStorage.getItem('systemtype');
  var res = await post('/admin/SysAuthMenu/CheckTokenGetMenuList', {
    systemtype: systemtype,
    page: 1,
    pageSize: 10000,
  });

  var platformMenu;
  if (res.status == 200) {
    platformMenu = res.data.data;
    const menuSetting = {
      idkey: 'menuid',
      pidkey: 'menupid',
    };
    var menuList = buildTree(platformMenu, menuSetting);

    let allMenu = [];
    try {
      allMenu = menuList[0].children;
    } catch {}

    return allMenu;
  } else {
    return [];
  }
}
//创建树状对象
function buildTree(data, setting) {
  if (data && data != null) {
    const rootNodes = data.filter((item) => item[setting.pidkey] === '0');
    return rootNodes.map((rootNode) => buildNode(data, rootNode, setting));
  } else {
    return [];
  }
}

//创建树节点
function buildNode(data, node, setting) {
  if (node.menutype == 'M') {
    var newNode = {
      path: node.menuurl ? node.menuurl : '/',
      name: node.menuresourcecode,
      meta: {
        title: node.menunodename,
        access: [],
        icon: node.menuicon ? node.menuicon : '',
        show: true,
      },
      component: (resolve) => require([`@/components/main`], resolve),
    };
    if (
      node.menutarget != null &&
      node.menutarget != '' &&
      node.menutarget != '/'
    ) {
      newNode.meta.access = [node.menucode, node.formtype, node.formtypename];
      newNode.component = (resolve) =>
        require([`@/view/${node.menutarget}`], resolve);
    }
    if (node.menutarget == 'main') {
      newNode.meta.access = [node.menucode, node.formtype, node.formtypename];
      newNode.component = (resolve) => require([`@/components/main`], resolve);
    }
    const children = data.filter(
      (item) =>
        item[setting.pidkey] === node[setting.idkey] && item.menutype == 'M',
    );

    if (children.length > 0) {
      newNode.children = children.map((child) =>
        buildNode(data, child, setting),
      );
      newNode.children.forEach((child) => {
        //将子项的权限增加到父项权限列表中
        if (child.meta.access) {
          child.meta.access.forEach((access) => {
            if (!newNode.meta.access.includes(access))
              newNode.meta.access.push(access);
          });
        }

        //判断子项是否为页面，父节点增加routeview  （三级菜单需要依赖这个）
        // if (
        //   element.menutarget != null &&
        //   element.menutarget != '' &&
        //   element.menutarget != '/' &&
        //   typeof element.menuurl != 'undefined'
        // ) {
        //   newNode.component = (resolve) =>
        //     require([`@/view/${node.menutarget}`], resolve);
        // }
      });
    }

    if (node.menushow == '否') delete newNode.meta.access;
  }

  return newNode;
}
